module.exports = __webpack_public_path__ + "assets/16f481ddad5a71652107423d1d03c51c.png";